import { render, staticRenderFns } from "./addcard.vue?vue&type=template&id=11a825ae&scoped=true"
import script from "./addcard.vue?vue&type=script&lang=js"
export * from "./addcard.vue?vue&type=script&lang=js"
import style0 from "./addcard.vue?vue&type=style&index=0&id=11a825ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a825ae",
  null
  
)

export default component.exports